import { Messages } from '@Config/messages';
import { RouteConfig } from '@Config/routes';
import lazyImport from '@Utils/lazyImport';

import { RouteInfo } from '../appRoutes';

const CreateThreadPage = lazyImport(() => import('./CreateThreadPage'));
const ForumPage = lazyImport(() => import('./ForumPage'));
const ForumThreadsPage = lazyImport(() => import('./ForumThreadsPage'));
const ThreadPage = lazyImport(() => import('./ThreadPage'));
const ExpertsPage = lazyImport(() => import('./ExpertsPage'));

const forumRoutes: RouteInfo[] = [
  {
    path: RouteConfig.Forum.template,
    component: ForumPage,
    title: Messages.forumPage,
    exact: true,
  },
  {
    path: RouteConfig.ForumThreadList.template,
    component: ForumThreadsPage,
    title: Messages.forumThreadsPageTitle,
  },
  {
    path: RouteConfig.ForumThreadPage.template,
    component: ThreadPage,
    title: Messages.forumThreadPageTitle,
  },
  {
    path: RouteConfig.CreateForumThread.template,
    component: CreateThreadPage,
    title: Messages.createForumThreadPageTitle,
  },
  {
    path: RouteConfig.ExpertsPage.template,
    component: ExpertsPage,
    title: Messages.expertsPageTitle,
  },
];

export default forumRoutes;
